// Shared testimonials data — used by Home carousel and /testimonials page.
// Order here = order on /testimonials; carousel uses the same order.
export const TESTIMONIALS = [
  {
    quote:
      "I could not have had a more positive experience with Ashley's tutoring and coaching services! She is always very well prepared for every session, she gives clear feedback and tips, and she really helps you see your improvement! She has very strong personal and communication skills and is able to make you feel very comfortable, no matter the topic! My personal improvement with Ashley in a short number of sessions was amazing and even inspired me to start tutoring!",
    name: "Grace Moore",
    role: "Pre-Dental Student",
  },
  {
    quote:
      "I highly recommend Dr. Delmar for any of your tutoring needs. She is not only knowledgeable with a wide range of topics, but also teaches problem-solving skills that can be used during exams. My experience was nothing but amazing from the friendly energy to the calm and patient approach during sessions. I also had amazing results from my sessions, including boosting my test-taking confidence and increasing my overall course grade. Amazing service that I would use again!",
    name: "Taylor Welykholowa",
    role: "Human Kinetics, 2nd Year",
  },
  {
    quote:
      "Ashley was a huge help to me writing my common app essay. I started the process with no idea what I would write about, but Ashley helped me use my prior experience as a swim coach and working at McDonald's to find transferable skills that were applicable to my program.",
    name: "Lindsay Wilson",
    role: "Chemistry, 1st Year",
  },
  {
    quote:
      "Working with Ashley meant so much more than just help with school. She was patient, kind, and genuinely committed to my success in pharmacology. She broke down difficult concepts instead of just making me memorize them and used real clinical scenarios to connect the material to actual practice. She also helped me think critically, not just about the right answer, but why it was right. Ashley created a safe, positive space where I never felt embarrassed to ask questions, no matter how many times I needed clarification. I looked forward to every session. Because of her, I'm not only more confident academically, I started believing in myself more.",
    name: "Danielle Lyew-you",
    role: "Nursing, 2nd Year",
  },
  {
    quote:
      "An incredible tutor! Ashley really knows how to explain things simply and understandably and is super easy to talk to. 10/10 Definitely book her!",
    name: "Tessa D.",
    role: "English Literature, Year 12",
  },
  {
    quote:
      "Dr. Delmar was the first person who made organic chemistry make sense. I went from a C+ to an A in one semester.",
    name: "Maya R.",
    role: "Pre-Vet, 3rd Year",
  },
  {
    quote:
      "I'm a first-gen applicant and I had no idea how MMIs worked. Her mock stations were tough, but she taught me how to reason through every step so I wouldn't get stuck during the real thing. I got into my top school thanks to her coaching.",
    name: "Jordan T.",
    role: "Entering Medical School",
  },
  {
    quote:
      "She didn't write my essay for me. She asked me questions that made the essay fall out of my head. I was so intimidated by the essay writing process at the beginning but Dr. Delmar made it easy.",
    name: "Priya K.",
    role: "Non-Traditional Applicant",
  },
];
